"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ImeiRequestStatus = void 0;
var ImeiRequestStatus = exports.ImeiRequestStatus = {
  valid: 'VALID',
  invalid: 'IN_VALID',
  expired: 'EXPIRED'
};